module.exports = __webpack_public_path__ + "img/game-box.e91fe3b7.png";